import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import useAuth from "../../hooks/useAuth";
import { AuthService } from "../../services/authservice";
import { getUser } from "../../api/user";
import { roleRoutes } from "../../utils/roles";

// Menú de usuario del header (avatar + "Ver mi cuenta" / "Cerrar sesión").
// Antes vivía al pie del sidebar; ahora va arriba a la derecha, como el mockup.
export default function UserMenu() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [storedColor, setStoredColor] = useState(null);

  useEffect(() => {
    if (user?.token) {
      getUser(user.token)
        .then((res) => setUserData(res))
        .catch((err) => console.error("Error fetching user data:", err));
    }
  }, [user]);

  useEffect(() => {
    const cachedConfig = localStorage.getItem("config");
    if (cachedConfig) {
      try {
        const configObject = JSON.parse(cachedConfig);
        if (configObject?.color) setStoredColor(configObject.color);
      } catch {
        // ignorar error de parseo
      }
    }
  }, []);

  const isInternalRole =
    user?.role === roleRoutes.admin ||
    user?.role === roleRoutes.superadmin ||
    user?.role === roleRoutes.systemSuperadmin ||
    user?.role === roleRoutes.support ||
    user?.role === roleRoutes.supervisor;

  const accountPath = isInternalRole ? "/admin/my-account" : "/home/my-account";
  // Configuración de empresa: admin/super editan en /admin/settings; comercio
  // y demás roles externos solo ven sus datos en /home/configuracion-empresa.
  const settingsPath = isInternalRole ? "/admin/settings" : "/home/configuracion-empresa";
  const displayName = userData?.company?.name || user?.name || "";

  const logOut = () => {
    AuthService.logout();
    window.location.replace("/login");
  };

  return (
    <Dropdown isOpen={open} toggle={() => setOpen(!open)} className="header-user">
      <DropdownToggle
        tag="button"
        caret={false}
        className="header-user__toggle"
        aria-label={t("Menú de usuario")}
      >
        <span
          className="material-symbols-outlined header-user__avatar"
          style={{ color: storedColor || "var(--color-primary)" }}
          aria-hidden="true"
        >
          account_circle
        </span>
        <span className="header-user__info">
          <span className="header-user__name">{displayName}</span>
          <span className="header-user__email">{user?.email}</span>
        </span>
        <span className="material-symbols-outlined header-user__chevron" aria-hidden="true">
          expand_more
        </span>
      </DropdownToggle>

      <DropdownMenu end className="header-user__menu">
        {/* Cabecera con identidad (como el mockup) */}
        <div className="header-user__head">
          <span className="header-user__head-name">{displayName || t("Mi cuenta")}</span>
          {user?.email && <span className="header-user__head-email">{user.email}</span>}
        </div>

        <DropdownItem
          className="header-user__item"
          onClick={() => navigate(accountPath)}
        >
          <span className="material-symbols-outlined" aria-hidden="true">
            person
          </span>
          {t("Mi cuenta")}
        </DropdownItem>

        <DropdownItem
          className="header-user__item"
          onClick={() => navigate(settingsPath)}
        >
          <span className="material-symbols-outlined" aria-hidden="true">
            settings
          </span>
          {t("Configuración de empresa")}
        </DropdownItem>

        <DropdownItem divider className="header-user__divider" />

        <DropdownItem
          className="header-user__item header-user__item--danger"
          onClick={logOut}
        >
          <span className="material-symbols-outlined" aria-hidden="true">
            logout
          </span>
          {t("Cerrar sesión")}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
